import { render, staticRenderFns } from "./BasicInfoChild.vue?vue&type=template&id=6e756a4f&scoped=true&"
import script from "./BasicInfoChild.vue?vue&type=script&lang=js&"
export * from "./BasicInfoChild.vue?vue&type=script&lang=js&"
import style0 from "./BasicInfoChild.vue?vue&type=style&index=0&id=6e756a4f&lang=scss&scoped=true&"
import style1 from "./BasicInfoChild.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e756a4f",
  null
  
)

export default component.exports